const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/user/app/$appId/request-prompt.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
const RequestPromptSearchSchema = z.object({
  type: z.string().optional()
});
export const Route = createFileRoute('/_main/user/app/$appId/request-prompt')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: RequestPromptSearchSchema
});